import React, { useState, useEffect } from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useSelector, useDispatch } from 'react-redux';
import { Dropdown } from 'react-bootstrap';
import { MultiSelect } from 'react-multi-select-component';
import { useTranslation } from 'react-i18next';
import * as todoAction from './store/Indicator.action';
import List from './List';
import { Page_Size, RightsAccess } from '../../../../Components/helper';
import IndicatorFilter from './IndicatorFilter';
import SearchBar from '../../../../Components/Utility/FilterAction/SearchBar';

function ProgressIndicator() {
  const dispatch = useDispatch();
  const { t } = useTranslation('common');

  const progressIndicator = 'progress-indicator';
  const reducers = useSelector((redState) => redState);
  const { reportsRight } = RightsAccess();

  const {
    IndicatorTodoListData: {
      indicatorListData,
      indicatorFilterValues: {
        searchText,
        selected_Season,
        selected_Year,
        selected_Month,
        selected_Brand,
        selected_SubBrand,
        selected_Supplier,
        selectedProductType,
        selected_Category1,
        selected_Category2,
        selected_Category3,
        selected_Category4,
        selected_CreatedBy,
        selected_ModifiedBy,
        selected_Status,
        selectedLicensor,
        selectedLicense,
        selectedLikeness,
        pageIndex,
        pageSize,
      },
      indicatorListTotalCount,
      indicatorSelectedIds,
    },
  } = reducers;
  const [selectedColumn, setSelectedColumn] = useState([]);

  const [state, setState] = useState({
    isLoading: false,
    hasMore: false,
    loading: true,
    totalRecords: null,
    searchLoaded: false,
    isExportLoading: false,
    isDownloadLoading: false,
    selectedCount: 0,
    requestId: null,
  });

  useEffect(() => {
    const callFn = async () => {
      let filterd = {};
      const obj = JSON.parse(localStorage.getItem('indicatorTodoListFilter'));
      if (obj) {
        filterd = {
          seasons: obj.selected_Season,
          year: obj.selected_Year,
          month: obj.selected_Month,
          brand: obj.selected_Brand,
          subBrand: obj.selected_SubBrand,
          supplier: obj.selected_Supplier,
          productTypeId: obj.selectedProductType,
          category1: obj.selected_Category1,
          category2: obj.selected_Category2,
          category3: obj.selected_Category3,
          category4: obj.selected_Category4,
          createdBy: obj.selected_CreatedBy,
          modifiedBy: obj.selected_ModifiedBy,
          status: obj.selected_Status,
          licensorId: obj.selectedLicensor,
          licenseId: obj.selectedLicense,
          likenessId: obj.selectedLikeness,
        };
        obj.pageIndex = 1;
        await dispatch(todoAction.filterSortData(obj));
      }
      const requestId = Date.now().toString();
      const params = {
        pageSize,
        pageIndex: 1,
        type: progressIndicator,
        ...filterd,
        requestId,
      };
      setState((prevState) => ({ ...prevState, isLoading: true, requestId }));
      const res = await dispatch(todoAction.getIndicatorList(params));
      if (res) {
        setState((prevState) => ({
          ...prevState,
          hasMore: true,
          isLoading: false,
        }));
      }
    };
    if (reportsRight) {
      callFn();
    }
  }, [dispatch, pageSize, reportsRight]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state?.searchLoaded) {
        const requestId = Date.now().toString();
        const params = {
          searchText,
          pageIndex: 1,
          pageSize: Page_Size,
          seasons: selected_Season,
          year: selected_Year,
          month: selected_Month,
          brand: selected_Brand,
          subBrand: selected_SubBrand,
          supplier: selected_Supplier,
          productTypeId: selectedProductType,
          category1: selected_Category1,
          category2: selected_Category2,
          category3: selected_Category3,
          category4: selected_Category4,
          createdBy: selected_CreatedBy,
          modifiedBy: selected_ModifiedBy,
          status: selected_Status,
          licensorId: selectedLicensor,
          licenseId: selectedLicense,
          likenessId: selectedLikeness,
          type: progressIndicator,
          requestId,
        };
        setState((searchEndState) => ({
          ...searchEndState,
          requestId,
        }));
        await dispatch(todoAction.getIndicatorList(params));
        setState((searchEndState) => ({
          ...searchEndState,
          isLoading: false,
          searchLoaded: false,
        }));
      }
    }, 1000);
    return () => clearTimeout(delayDebounceFn);
  }, [searchText, dispatch, state.searchLoaded]);

  useEffect(() => {
    if (indicatorListTotalCount > indicatorListData?.length) {
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: true,
      }));
    } else
      setState((inInfinitestate) => ({
        ...inInfinitestate,
        hasMore: false,
      }));
  }, [indicatorListData?.length, indicatorListTotalCount]);

  const handlePageNextInScroll = async () => {
    let index = pageIndex;
    index += 1;
    const params = {
      searchText,
      seasons: selected_Season,
      year: selected_Year,
      month: selected_Month,
      brand: selected_Brand,
      subBrand: selected_SubBrand,
      supplier: selected_Supplier,
      productTypeId: selectedProductType,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      createdBy: selected_CreatedBy,
      modifiedBy: selected_ModifiedBy,
      licensorId: selectedLicensor,
      licenseId: selectedLicense,
      likenessId: selectedLikeness,
      pageIndex: index,
      pageSize,
      totalRecords: indicatorListTotalCount,
      status: selected_Status,
      isScrolled: true,
      type: progressIndicator,
    };

    const obj = {
      pageIndex: index,
      pageSize,
    };
    setState((prevState) => ({ ...prevState, isLoading: true }));

    await dispatch(todoAction.filterSortData(obj));
    await dispatch(todoAction.getIndicatorList(params));
    setState((prevState) => ({ ...prevState, isLoading: false }));
  };

  const exportFiles = async (type) => {
    const params = {
      searchText,

      seasons: selected_Season,
      year: selected_Year,
      month: selected_Month,
      brand: selected_Brand,
      subBrand: selected_SubBrand,
      supplier: selected_Supplier,
      productTypeId: selectedProductType,
      category1: selected_Category1,
      category2: selected_Category2,
      category3: selected_Category3,
      category4: selected_Category4,
      createdBy: selected_CreatedBy,
      modifiedBy: selected_ModifiedBy,
      licensorId: selectedLicensor,
      licenseId: selectedLicense,
      likenessId: selectedLikeness,
      pageIndex: 1,
      pageSize: indicatorListTotalCount,
      type: progressIndicator,
      productIds: indicatorSelectedIds,
      downloadType: type,
      status: selected_Status,
    };

    if (type === 'pdf') {
      setState((prevState) => ({ ...prevState, isDownloadLoading: true }));
      await dispatch(todoAction.exportToPdf(params));
      setState((prevState) => ({ ...prevState, isDownloadLoading: false }));
    } else {
      setState((prevState) => ({ ...prevState, isExportLoading: true }));
      await dispatch(todoAction.exportExcel(params));
      setState((prevState) => ({ ...prevState, isExportLoading: false }));
    }
  };
  const getCount = (selectedCnt) => {
    setState((prevState) => ({
      ...prevState,
      selectedCount: selectedCnt.length,
    }));
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((prevState) => ({
      ...prevState,
      isLoading: true,
      searchLoaded: true,
    }));
    const obj = {
      searchText: targetValue,
    };
    await dispatch(todoAction.filterSortData(obj));
  };

  const mappedArray = [
    { label: 'Product Description', display: 'description', value: 1 },
    { label: 'Supplier', display: 'supplierNames', value: 2 },
    { label: 'Brand', display: 'brand', value: 3 },
    { label: 'Season', display: 'seasonId', value: 4 },
    { label: 'Month', display: 'month', value: 5 },
    { label: 'Year', display: 'year', value: 6 },
    { label: 'Category 1', display: 'catOneId', value: 7 },
    { label: 'Category 2', display: 'catTwoId', value: 8 },
    { label: 'Category 3', display: 'catThreeId', value: 9 },
    { label: 'Category 4', display: 'catFourId', value: 10 },
  ];

  const handleSelectChange = (selected) => {
    setSelectedColumn([...selected]);
  };

  useEffect(() => {
    return () => {
      const obj = {
        searchText: '',
      };
      dispatch(todoAction.filterSortData(obj));
    };
  }, [dispatch]);
  return (
    <>
      <div>
        <div className="page-title-filter sticky">
          <div className="title-container d-flex align-items-center">
            <h4 className="title">{t('REPORTS.PROGRESS_TO_DO')}</h4>
          </div>
          <div className="search-filter">
            {indicatorSelectedIds && indicatorSelectedIds?.length > 0 && (
              <span className="d-none d-md-inline-block txt-selected-cnt">
                {indicatorSelectedIds?.length} {t('COSTING_TO_DO_LIST.RECORD_SELECTED')}
              </span>
            )}
            {indicatorListTotalCount > 0 && (
              <span className="d-none d-md-inline-block txt-selected-cnt">
                {indicatorListTotalCount} {t('COSTING_TO_DO_LIST.TOTAL_RECORDS')}
              </span>
            )}
            <div className="mobile-multi-search">
              {/* title-search-container */}
              <div className="custom-multiselect ">
                <MultiSelect
                  name="attributes"
                  options={mappedArray}
                  className="custom-multiselect-PO"
                  value={selectedColumn}
                  labelledBy={t('PROGRESS_INDICATOR.SELECT_ATTRIBUTES')}
                  onChange={handleSelectChange}
                />
              </div>

              <SearchBar placeholder={t('PROGRESS_INDICATOR.SEARCH')} onSearch={handleSearch} value={searchText} />
            </div>
            <div className="mobile-btns">
              <IndicatorFilter />
              <Dropdown className="supplier-more-option">
                <Dropdown.Toggle disabled={indicatorListData.length < 1}>
                  <button className="filter-btn filter-button_delete" type="button" title={t('COSTING_TO_DO_LIST.EXPORT_EXCEL')}>
                    <i title={t('PROGRESS_INDICATOR.DOWNLOAD_EXCEL')} className="icon-download" />
                  </button>
                </Dropdown.Toggle>
                <Dropdown.Menu align="end">
                  <a className={state.isDownloadLoading ? 'dropdown-item disabled-btn' : 'dropdown-item'} href={() => false} onClick={() => exportFiles('pdf')}>
                    {state.isDownloadLoading ? t('PROGRESS_INDICATOR.DOWNLOADING') : t('PROGRESS_INDICATOR.DOWNLOAD_PDF')}
                  </a>
                  <a
                    className={state.isExportLoading ? 'dropdown-item dhttps://meet.google.com/axh-zxif-hmkisabled-btn' : 'dropdown-item'}
                    href={() => false}
                    onClick={() => exportFiles('excel')}
                  >
                    {state.isExportLoading ? t('PROGRESS_INDICATOR.EXPORTING') : t('PROGRESS_INDICATOR.EXPORT_EXCEL')}
                  </a>
                </Dropdown.Menu>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
      <div className="scroll-container">
        <span className="top" />
        <span className="left" />
        <span className="right" />
        <div className="all-scroll">
          <div
            id="scrollableDiv"
            style={{
              height: '100%',
              overflow: 'scroll',
            }}
          >
            <InfiniteScroll
              dataLength={indicatorListData.length}
              hasMore={state.hasMore}
              next={() => handlePageNextInScroll()}
              scrollableTarget="scrollableDiv"
              className="fixed-col-container"
            >
              <List loading={state.isLoading} getSelectedCount={getCount} mappedArray={selectedColumn} />
            </InfiniteScroll>
          </div>
        </div>
      </div>
    </>
  );
}

export default ProgressIndicator;
